module.exports = __webpack_public_path__ + "img/interview-blog-logo.024b63c9.svg";